import { render, staticRenderFns } from "./UpdateLanguage.vue?vue&type=template&id=64ac99c8&scoped=true"
import script from "./UpdateLanguage.vue?vue&type=script&lang=js"
export * from "./UpdateLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac99c8",
  null
  
)

export default component.exports